// app/javascript/controllers/p2p/card_mask_controller.js
//
// Stimulus-контроллер для автоформатирования номера банковской карты.
// Отображает: 0000 0000 0000 0000
// При отправке формы: 0000000000000000 (без пробелов)
//
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    // Если target не задан — контроллер на самом input'е
    this.inputEl = this.hasInputTarget ? this.inputTarget : this.element
    this.inputEl.addEventListener("input", this._onInput)

    // Перед отправкой формы убираем пробелы
    this.form = this.inputEl.closest("form")
    if (this.form) {
      this.form.addEventListener("submit", this._onSubmit)
    }
  }

  disconnect() {
    this.inputEl.removeEventListener("input", this._onInput)
    if (this.form) {
      this.form.removeEventListener("submit", this._onSubmit)
    }
  }

  // Форматирование при вводе: вставляем пробелы каждые 4 цифры
  _onInput = (e) => {
    const el = e.target
    const maxDigits = parseInt(el.dataset.cardMaskMaxDigits || "16", 10)
    const cursor = el.selectionStart
    const raw = el.value.replace(/\D/g, "").slice(0, maxDigits)
    const formatted = raw.replace(/(.{4})/g, "$1 ").trim()
    const diff = formatted.length - el.value.length

    el.value = formatted

    // Корректируем позицию курсора
    const newCursor = cursor + diff
    el.setSelectionRange(newCursor, newCursor)
  }

  // Перед submit — убираем пробелы из значения
  _onSubmit = (_e) => {
    this.inputEl.value = this.inputEl.value.replace(/\s/g, "")
  }

  // Action-метод (можно вызывать через data-action)
  format(e) {
    this._onInput(e)
  }
}
